import { createActions, createReducer } from 'reduxsauce'

import ConsultaCedidosPeloMPService from '../../servicos/ConsultaRemuneracaoADMRHService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaConsultaCedidosPeloMPInicio: [],
    buscaConsultaCedidosPeloMPErro: ['erro'],
    buscaConsultaCedidosPeloMPSucesso: ['consultaCedidosPeloMP'],
    limpar: [],
    setConsultaCedidosPeloMPEstadoDT: ['estado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    dataSincronizacaoDados: null,
    estadoDT: {},
}

// Ação para busca completa
Creators.buscaConsultaCedidosPeloMP = (filtro, tipoServidor) => {
    return dispatch => {
        dispatch(Creators.buscaConsultaCedidosPeloMPInicio())
        let serv = new ConsultaCedidosPeloMPService()
        return serv
            .consultarQuadrosMembros(filtro, tipoServidor)
            .then(response => dispatch(Creators.buscaConsultaCedidosPeloMPSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConsultaCedidosPeloMPErro(error)))
    }
}

const buscaConsultaCedidosPeloMPInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaConsultaCedidosPeloMPErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaConsultaCedidosPeloMPSucesso = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        lista: action.consultaCedidosPeloMP.resultado,
        dataSincronizacaoDados: action.consultaCedidosPeloMP.dataSincronizacaoDados,
        carregando: false,
        fonte: action.consultaCedidosPeloMP.fonte,
    }
}

const limpar = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const setConsultaCedidosPeloMPEstadoDT = (state = INITIAL_STATE, action) => {
    return { ...state, estadoDT: action.estado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONSULTA_CEDIDOS_PELO_MP_INICIO]: buscaConsultaCedidosPeloMPInicio,
    [Types.BUSCA_CONSULTA_CEDIDOS_PELO_MP_ERRO]: buscaConsultaCedidosPeloMPErro,
    [Types.BUSCA_CONSULTA_CEDIDOS_PELO_MP_SUCESSO]: buscaConsultaCedidosPeloMPSucesso,
    [Types.LIMPAR]: limpar,
    [Types.SET_CONSULTA_CEDIDOS_PELO_MP_ESTADO_DT]: setConsultaCedidosPeloMPEstadoDT,
})
